/* GENERATED FILE */
import { forwardRef } from "react";
import variants from "../defs/arrow-bottom-left-rec";
import IconBase from "../lib/icon-base";
import type { Icon } from "../lib/types";

const I: Icon = forwardRef((props, ref) => (
	<IconBase ref={ref} {...props} variants={variants} />
));

I.displayName = "ArrowBottomLeftRec";
export { I as ArrowBottomLeftRec };
